import './nav';

import loadPolyfills from "dynamic-polyfill/src";
import polyfills from '../../../polyfills.mjs';
import promiseIdle from './lib/promise-idle';
import ready from './lib/ready';
import Scrolled from './lib/Scrolled';
import {trigger} from './lib/events';
import replaceImageWithSvgSource from './lib/replace-image-with-svg-source';

Promise.resolve()
	.then(() => loadPolyfills({
		polyfills: polyfills,
		// options: ['gated', 'always'],
		// minify: true,
		// Real User Monitoring
		rum: true,
	}))
	.then(() => trigger.call(document, 'ready'))
	.catch(console.warn);

ready().then(promiseIdle()).then(function init() {
	(new Scrolled()).observe();

	replaceImageWithSvgSource(document.querySelector('img.header__logo'))
		.then(svg => svg.querySelectorAll('style, #light, #dark, #red').forEach(node => node.remove()));

	document.querySelectorAll('img[data-replace-with-source]').forEach(replaceImageWithSvgSource);
});
